import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const Domain_MessagingUI = Object.freeze({
    _id: '1fe9b99258a215632014eec2e4394bc9',
    namespace: 'MessagingUI',
});
export const messagingPermissionKeys = generateKeyNamesByAccessLevel(Domain_MessagingUI.namespace, defaultUIAccessLevels);
//# sourceMappingURL=messaging.js.map